import React from 'react';

import { BaseLabel, type BaseLabelProps } from './BaseLabel';
import { css } from 'emotion';

const iconStyle = css`
  margin-right: 5px;
`;

interface LabelProps extends BaseLabelProps {
  icon?: React.ReactElement<any>;
}

export const Label = (props: LabelProps) => {
  const { icon, children, ...otherProps } = props;

  if (!icon) {
    return <BaseLabel {...props} />;
  }

  const iconWithProps = React.cloneElement(icon, { className: iconStyle });

  return (
    <BaseLabel {...otherProps}>
      {iconWithProps}
      {children}
    </BaseLabel>
  );
};
